import React from 'react'

import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/global.css'
import Rotas from './routes'

function App() {
  return (
    <div className="App">
      <Rotas />
    </div>
  )
}

export default App
